import { appUrl } from 'utils/wrappers';

import Base from 'app/collections/base';
import EventPayload from 'app/models/event_payload';

export default Base.extend({
  model: EventPayload,
  key: 'payloads',

  url() {
    return appUrl(`events/${this.eventID}/payloads?mode=${this.mode}`);
  },

  initialize(models, { event }) {
    this.mode = event.get('mode');
    this.eventID = event.get('id');
  },
});



// WEBPACK FOOTER //
// ./app/collections/event_payloads.js